// 约定的错误码含义
const errCode = {
  userNotExist: 2000, // 用户不存在
  invalidToken: 4001, // 无效token
  invalidUser: 4002, // 非法用户
  OrderNotExist: 2200, // 订单不存在
  ProductNotExist: 5000, // 未能获取产品详情
  orderPermissionError: 2202, // 无法查看他人订单
  tuanClosed: 2222, // 团已关闭
  tuanExpired: 2221, // 团已过期
  newUserRestriction: 2203, // 新用户专享
  commonConfirm: 1008, //  通用弹窗
  needUserPhone: 6006, // 订单缺失手机号
};
const env = {
  Weixin: 'weixin', // 微信浏览器
  browser: 'browser', // 非微信浏览器
  PC: 'PC', // pc端
  Android: 'android', // android机器
  iOS: 'ios', // ios机器
  APP: 'app', // webview环境
};
export default {
  errCode,
  env,
}
